import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgBlockedUserPlaceholderS = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 10.8,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M15.023 13.805a3.8 3.8 0 0 0 1.23-2.808V8.855a3.83 3.83 0 0 0-3.83-3.829h-.847a3.83 3.83 0 0 0-3.828 3.829v2.142c0 1.11.473 2.11 1.23 2.808.738.683.709 1.86-.073 2.492a3.1 3.1 0 0 1-.903.51c-1.265.459-2.861 1.135-4.039 1.966a.265.265 0 0 0-.044.39A10.77 10.77 0 0 0 12 22.8a10.77 10.77 0 0 0 8.08-3.637.265.265 0 0 0-.043-.39c-1.178-.83-2.774-1.507-4.04-1.966a3.1 3.1 0 0 1-.902-.51 1.648 1.648 0 0 1-.072-2.492"
      }), /*#__PURE__*/jsx("circle", {
        cx: 16.89,
        cy: 16.2,
        r: 4.35,
        fill: "#9EA0A0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M16.89 11.85a4.35 4.35 0 1 1 0 8.7 4.35 4.35 0 0 1 0-8.7m2.765 2.84-4.275 4.275a3.15 3.15 0 0 0 4.275-4.275m-2.765-1.64a3.15 3.15 0 0 0-2.438 5.145l4.433-4.433a3.14 3.14 0 0 0-1.995-.712"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgBlockedUserPlaceholderS$1 = SvgBlockedUserPlaceholderS;

export { SvgBlockedUserPlaceholderS$1 as default };
